import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getErrorMessageFromAPI } from '@/utilz';
import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';
import { saveOCClaim } from '@/views/screens/Claims/data-provider/save-over-charge-claim';
import type { SaveOCClaimRequestParams } from '@/views/screens/Claims/data-provider/save-over-charge-claim/api';

export const useCreateOCClaim = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: SaveOCClaimRequestParams) => saveOCClaim(payload),
    onError: (e: { response: any }) => {
      showNotification({
        message: getErrorMessageFromAPI(e, 'Failed to create Claim'),
        type: NOTIFICATION_TYPES.ERROR,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ exact: false, queryKey: ['claims-over-charge-list'] });
      showNotification({
        message: 'Successfully created claim.',
        type: NOTIFICATION_TYPES.SUCCESS,
      });
    },
  });
};
